import type { QueryResult } from '@apollo/client'
import { useCallback } from 'react'

import { useGetVerifAIFlags } from '@/lib/apollo/query/getVerifAIFlags'
import type { QueryVars, Response } from '@/lib/apollo/query/getVerifAIFlags/query'

type UseVerifyAI = () => {
  fetchVerifAIResults: (
    customerId: string,
    subjectId: string,
  ) => Promise<QueryResult<Response, QueryVars>>
  loading: boolean
  error: Error | undefined
  data: Response['getVerifAIFlags'] | undefined
}

const useVerifAi: UseVerifyAI = () => {
  const [fetch, { loading, error, data }] = useGetVerifAIFlags({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  })

  const fetchVerifAIResults = useCallback(
    async (customerId: string, subjectId: string) =>
      fetch({
        variables: {
          customerId,
          subjectId,
        },
      }),
    [fetch],
  )

  return {
    fetchVerifAIResults,
    loading,
    error,
    data: data?.getVerifAIFlags ?? undefined,
  }
}

export default useVerifAi
